import { PageRef } from 'providers/page-ref';

export type TestNavigationChildPageParams = {
  mode?: string;
  filter?: string;
  debug?: string;
};

export const ITestNavigationChildPage: PageRef<TestNavigationChildPageParams, void> = {
  pageName: 'TestNavigationChildPage',
} as PageRef<TestNavigationChildPageParams, void>;
